<template>
    <Head>
        <title>Журнал тарифов</title>
    </Head>

    <authenticated-layout :notifications="notifications" >

        <template #header>
            <organization-navigation v-if="organizationId" :organization-id="organizationId"/>
            <tariff-navigation :organization-id="organizationId"/>
        </template>


        <div class="bg-white p-6">

            <div class="flex flex-row justify-end p-2 gap-2">
                <a target="_blank" :href="organizationId ? route('tariffs.logs.unload', organizationId) : route('tariffs.logs.unload')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current text-blue-700" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM3.517 14.841a1.13 1.13 0 0 0 .401.823q.195.162.478.252.284.091.665.091.507 0 .859-.158.354-.158.539-.44.187-.284.187-.656 0-.336-.134-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.566-.21l-.621-.144a1 1 0 0 1-.404-.176.37.37 0 0 1-.144-.299q0-.234.185-.384.188-.152.512-.152.214 0 .37.068a.6.6 0 0 1 .246.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.2-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.439 0-.776.15-.337.149-.527.421-.19.273-.19.639 0 .302.122.524.124.223.352.367.228.143.539.213l.618.144q.31.073.463.193a.39.39 0 0 1 .152.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.167.07-.413.07-.175 0-.32-.04a.8.8 0 0 1-.248-.115.58.58 0 0 1-.255-.384zM.806 13.693q0-.373.102-.633a.87.87 0 0 1 .302-.399.8.8 0 0 1 .475-.137q.225 0 .398.097a.7.7 0 0 1 .272.26.85.85 0 0 1 .12.381h.765v-.072a1.33 1.33 0 0 0-.466-.964 1.4 1.4 0 0 0-.489-.272 1.8 1.8 0 0 0-.606-.097q-.534 0-.911.223-.375.222-.572.632-.195.41-.196.979v.498q0 .568.193.976.197.407.572.626.375.217.914.217.439 0 .785-.164t.55-.454a1.27 1.27 0 0 0 .226-.674v-.076h-.764a.8.8 0 0 1-.118.363.7.7 0 0 1-.272.25.9.9 0 0 1-.401.087.85.85 0 0 1-.478-.132.83.83 0 0 1-.299-.392 1.7 1.7 0 0 1-.102-.627zm8.239 2.238h-.953l-1.338-3.999h.917l.896 3.138h.038l.888-3.138h.879z"/>
                    </svg>
                </a>
            </div>

            <div class="grid grid-cols-12 text-sm items-end text-gray-700 font-semibold uppercase p-2 gap-4">
                <span class="col-span-2">Tariff id</span>
                <span>Priority</span>
                <span>Reason type</span>
                <span class="col-span-2">Action</span>
                <span>Type</span>
                <span>Amount</span>
                <span>Min amount</span>
                <span>Max amount</span>
                <span>Comment</span>
                <span class="text-center">Created (UTC)</span>
            </div>

            <div class="grid grid-cols-12 border-t p-2 gap-4 text-xs break-words" v-for="row in result">
                <span class="col-span-2">{{ row.tariffId }}</span>
                <span>{{ row.priority }}</span>
                <span>{{ row.reasonType }}</span>
                <span class="col-span-2">{{ row.action }}</span>
                <span>{{ row.type }}</span>
                <span>{{ row.amount }}</span>
                <span>{{ row.minAmount }}</span>
                <span>{{ row.maxAmount }}</span>
                <span>{{ row.comment }}</span>
                <span class="text-center">{{ moment(row.createdAt).utc().format('L LTS') }}</span>
            </div>

        </div>

    </authenticated-layout>

</template>

<script>
import moment from "moment";
import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import TariffNavigation from '@/Components/Navigation/Tariffs';
import OrganizationNavigation from '@/Components/Navigation/Organization';
import VButton from "@/Components/Button";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        TariffNavigation, OrganizationNavigation,
        VButton,
    },
    props: {
        notifications: Array,
        result: Object,
        organizationId: String,
    },
    methods: {
        moment,
    },
}
</script>
